import { config } from '@yola/ws-sdk';

// It's needed to avoid importing both config modules from ws-sdk in middlewares to get actionTypes &
// from editor to get selectors
export default config.actionTypes;
